<script>
export default {
  data () {
    return {
      isMobile: false,
      isClient: false
    }
  },
  mounted () {
    this.checkIsMobile()
    this.isClient = true
    window.addEventListener('resize', this.checkIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkIsMobile)
  },
  methods: {
    checkIsMobile () {
      this.isMobile = window.innerWidth <= 768
    }
  }
}

</script>
